import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { useCurrentUser } from '@hero/hooks-shared';
import { getSentryUser } from '@hero/core';

export function useSentryUser() {
  const { user } = useCurrentUser();

  useEffect(() => {
    if (user) {
      Sentry.setUser(getSentryUser(user));
    } else {
      Sentry.setUser(null);
    }
  }, [user]);
}
